const getTestId = (id) => process.env.NODE_ENV === 'test' ? { 'data-testid': id } : {};
export default getTestId;
